import { useState, useEffect } from 'react';
import { filterVacanciesByDepartment } from '../utils';
import { DEFAULT_DEPARTMENT, ALL_DEPARTMENTS_TEXT } from '../../shared/config/constants';

const useFilterByDepartment = (vacancies) => {
    const [filteredCareers, setFilteredCareers] = useState(vacancies);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        if (!vacancies?.length) {
            setDepartments([]);
            setFilteredCareers(vacancies);
            return
        }

        // Extract unique departments
        const uniqueDepartments = [
            { id: DEFAULT_DEPARTMENT, name: ALL_DEPARTMENTS_TEXT },
            ...new Map(
                vacancies
                    .filter(vacancy => vacancy?.department)
                    .map(vacancy => [
                        vacancy.department.id,
                        vacancy.department
                    ])
            ).values()
        ];

        setDepartments(uniqueDepartments);

        setFilteredCareers(vacancies);
    }, [vacancies]);

    const handleDepartmentChange = (departmentId) => {
        const filtered = filterVacanciesByDepartment(vacancies, departmentId);
        setFilteredCareers(filtered);
    };

    return {
        filteredCareers,
        departments,
        handleDepartmentChange,
    };
};

export default useFilterByDepartment;
